export default function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-collection/src/keys.js
// module id = ../../../../d3-collection/src/keys.js
// module chunks = 3